import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useFestivalSettings } from '@/services/festivalService';
import './festival.css';

/** Route-scoped presentation only. No route remounts or shopping state changes. */
export function FestivalTheme() {
  const { data } = useFestivalSettings();
  const { pathname } = useLocation();
  const storefront = !/^\/admin(?:\/|$)/.test(pathname);
  useEffect(() => {
    if (data?.enabled && storefront) document.documentElement.dataset.festival = 'diwali';
    else delete document.documentElement.dataset.festival;
    return () => { delete document.documentElement.dataset.festival; };
  }, [data?.enabled, storefront]);
  return null;
}
